import React from 'react';
import { formatTime } from '../data';
import { StandardActionView } from './StandardActionView';
import { ProductionActionView } from './ProductionActionView';
import { TransportActionView } from './TransportActionView';
import { actionTypes } from '../data';
import { DraggableActionItem } from './DraggableActionItem';

function EmpireView({
  startTime,
  totalTime,
  planets,
  timeline,
  handleDelete,
  handleMove,
  changeSetProduction,
  changeTransportAction,
  handleToggleDeactivate,
  setDraggedItem,
  draggedItem,
  updatePreviewState
}) {
  const onMoveAction = (planetId, id, direction) => {
    handleMove(planetId, id, direction);
  };
  
  const onDeleteAction = (planetId, id) => {
    handleDelete(planetId, id);
  };
  
  const onToggleDeactivate = (planetId, id) => {
    handleToggleDeactivate(planetId, id);
  };
  
  // Handle drag and drop movement
  const moveItem = (sourcePlanetId, sourceIndex, targetPlanetId, targetIndex, newAction = null) => {
    if (newAction) {
      // Adding a new action from planet display
      handleMove(targetPlanetId, -1, 'add', newAction, targetIndex);
    } else {
      // Moving an existing action
      if (sourcePlanetId === targetPlanetId) {
        // Moving within the same planet
        const direction = sourceIndex < targetIndex ? 'down' : 'up';
        handleMove(sourcePlanetId, sourceIndex, direction, null, targetIndex);
      } else {
        // Moving between planets
        handleMove(sourcePlanetId, sourceIndex, 'move', targetPlanetId, targetIndex);
      }
    }
  };
  
  const invalid = timeline.some((element) => element.valid === false);
  const header_bg = (invalid ? "bg-red-400" : "");
  
  return (
    <div className="empire-view h-full flex flex-col bg-gray-800 text-white">
      <div className="sticky top-0 bg-gray-700 p-3 z-10">
        {/* Total Time Header */}
        <header className={"text-xl font-bold text-center text-gray-50 " + header_bg}>
          Total Time: {formatTime(totalTime)}
        </header>
      </div>
      
      <div className="flex-1 overflow-auto">
        <div className="flex p-4 min-w-max">
          {/* Actions List - one column per planet */}
          {Object.keys(planets).map((planetId) => {
            return (
              <div key={"timeline-"+planetId} className="mx-2 min-w-[300px] flex flex-col">
                <div className="sticky top-0 z-20 bg-gray-800">
                  <div className=" pb-2">
                    <h3 className="text-lg font-semibold bg-gray-700 p-2 rounded-t-lg">{planets[planetId]["name"]}</h3>
                  </div>
                  
                </div>
                <ul className="space-y-2 bg-gray-700 p-2 rounded-b-lg flex-1">
                  {timeline.filter((action) => (action.planetId == planetId && action.forceShow === true) || (action.planetId == planetId && (action.editable || action.type===actionTypes.TRANSPORT))).map((action, idx) => {
                    // Extract numerical index from action.index if it's a string
                    const actionIndex = typeof action.index === 'string' ? 
                      parseInt(action.index.split('.')[0]) : 
                      action.index;
                    
                    // Only make editable actions draggable
                    const actionView = action.displayType === undefined ? 
                      (<StandardActionView key={action.index} startTime={startTime} action={action} onMoveAction={onMoveAction} onDeleteAction={onDeleteAction} onToggleDeactivate={onToggleDeactivate} last={action.index === (timeline.length - 1)} />) :
                      action.displayType === 'SET_PROD' ?
                      (<ProductionActionView showExtraWait={true} changeSetProduction={changeSetProduction} key={action.index} startTime={startTime} action={action} onMoveAction={onMoveAction} onDeleteAction={onDeleteAction} onToggleDeactivate={onToggleDeactivate} last={action.index === (timeline.length - 1)} />) :
                      action.displayType === 'TRANSPORT' ?
                      (<TransportActionView planets={planets} changeTransportAction={changeTransportAction} key={action.index} startTime={startTime} action={action} onMoveAction={onMoveAction} onDeleteAction={onDeleteAction} onToggleDeactivate={onToggleDeactivate} last={action.index === (timeline.length - 1)} />) :
                      null;
                    
                    return action.editable ? (
                      <DraggableActionItem 
                        key={action.index} 
                        index={actionIndex} 
                        planetId={action.planetId} 
                        moveItem={moveItem}
                        actionData={action}
                        setDraggedItem={setDraggedItem}
                        updatePreviewState={updatePreviewState}
                      >
                        {actionView}
                      </DraggableActionItem>
                    ) : (
                      <div key={action.index}>
                        {actionView}
                      </div>
                    );
                  })}
                </ul>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default EmpireView;
